export class ControlItem {
    Type?: string;
    Min?: number;
    Max?: number;
    StepSize?: number;
    DisplayScale?: number;
    Items: any[] = [];
}
